import { render, staticRenderFns } from "./ModalAlterarAluguelPrestador.vue?vue&type=template&id=ad89a626&scoped=true"
import script from "./ModalAlterarAluguelPrestador.vue?vue&type=script&lang=ts"
export * from "./ModalAlterarAluguelPrestador.vue?vue&type=script&lang=ts"
import style0 from "./ModalAlterarAluguelPrestador.vue?vue&type=style&index=0&id=ad89a626&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad89a626",
  null
  
)

export default component.exports